import { HTTP_STATUSES } from "@miplatform/constants";
import { useCategories } from "@mibuildweb/hooks";

export const useAttributeDetailsTabViewModel = () => {
  const { getCategories, setCategories, categories } = useCategories();

  const fetchCategories = async () => {
    const response = await getCategories();
    if (response.status === HTTP_STATUSES.OK) {
      setCategories(response.data);
    }
  };

  return {
    fetchCategories,
    categories,
  };
};
